import React, { Component } from 'react';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

import { toggleAddProgrammePopup, toggleNotification } from '../../redux/reducers/view';
import { getUserProgramsFullRequest } from '../../redux/reducers/userProgramsFull';

import Popup from '../Popup';
import AddCodeForm from '../Form/AddCodeForm';

import { commonStyles, COLORS } from '../../styles/styles';
import addCodeKeyImage from '../../assets/add_code_key.svg';


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';


import AvatarCirce from '../AvatarCircle';

import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBIcon } from 'mdbreact';
import { connectedUsersRequest } from '../../redux/reducers/connectedUsers';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';
import { systemRequest } from '../../redux/reducers/system';

class SystemPopup extends Component {
  state = {
    modal: true
  };

  toggle = () => {
   this.props.toggleAddProgrammePopup(false)
  }
  render() {
    return (
      // <Dialog
      //   open={true}
      //   onClose = {handleCloseNow}
      //   aria-labelledby="alert-dialog-title"
      //   aria-describedby="alert-dialog-description"
      //   classes={{paper:classes.dialogPaper}}
      // >
      //   <div style={{backgroundColor:'white', padding:8}}>
      //     <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">
      //     Please enter the code of the program you would like to add</DialogTitle>
      //     <DialogContent className={classes.dialogContent}>
      //       <AddCodeForm/>
      //     </DialogContent>
      //   </div>
      // </Dialog>
      <MDBContainer>
        <MDBModal isOpen={this.props.showSystemAlert}  centered >
          <MDBModalHeader id="alert-dialog-title" className="secondary-color m-2" > 
          <div className="dialogHeader">System Alert</div></MDBModalHeader>
          <MDBModalBody>
             {this.props.system && this.props.system.message} 
      
          <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}>{this.props.loading && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
          <div style={{position:'absolute', top:"40%", width:'100%'}}>
        <ScaleLoader
         
         height={35}
         width={4}
         radius={2}
         margin='2px'
        color={COLORS.cornerstoneRed}
         loading={true}
       />
       </div>
        </div>}</ReactCSSTransitionGroup>
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn className="btn-sm" color="secondary" onClick={this.props.handleRetry}>Retry</MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    );
    }
  }

const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
  senderAvatar: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 500,
    color: '#50E3C2',
    flexShrink: 0,
    marginRight: 7,
    backgroundColor: '#4A4A4A',
    width: `70px`,
    height: `70px`,
  },

});

const mapStateToProps = state => ({
  system: state.systemReducer.system,
  loading: state.systemReducer.fetching
});
const mapDispatchToProps = dispatch => ({
  systemRequest: () => dispatch(systemRequest())
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('showSystemAlert', 'toggleShowSystemAlert', false),
  withHandlers({
    handleRetry: props => () => {
      props.systemRequest();
     }
  }),
  lifecycle({
    componentWillUnmount() {
      //this.props.getUserProgramsFullRequest();
    },
    componentWillReceiveProps(nextProps){
      if(nextProps.system && nextProps.system.success==true && nextProps.system!=this.props.system){
        
        this.props.toggleShowSystemAlert(nextProps.system.success)
      }else if (nextProps.system && nextProps.system!=this.props.system){
       
        this.props.toggleShowSystemAlert(nextProps.system.success)
      }
    }
  }),
  withStyles(styles),
)(SystemPopup);

SystemPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  toggleAddProgrammePopup: PropTypes.func,
};
